import React from "react";
import { Form } from "antd";
import { Button, Message, Input } from "../../BP2Components";
import Widget from "../../Widget/Widget";
import { injectIntl } from "react-intl";
import SettingsModal from "../../Modal/SettingsModal";
import AdvancedSearchSettings from "../WidgetsSettings/AdvancedSearch/AdvancedSearchSettingsModal";
import IntlMessages from "@util/IntlMessages";

class WrappedAdvancedSearchForm extends React.Component {
   getFields(value) {
      const { getFieldDecorator } = this.props.form;
      const children = [];

      if (value && value.searchInput) {
         value.searchInput.map((input) => {
            if (input.checked === true) {
               children.push(
                  <div key={input.key} style={{ display: "flex", padding: "6px 0", marginLeft: "10px" }}>
                     <Form.Item label={input.label}>
                        {getFieldDecorator(`${input.label}`, {
                           rules: [
                              {
                                 required: true,
                                 message: "Input something!"
                              }
                           ]
                        })(<Input placeholder="placeholder" />)}
                     </Form.Item>
                  </div>
               );
            }
            return null;
         });
      }
      return children;
   }

   handleSearch = (e) => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
         console.log("Received values of form: ", values);
      });
   };
   saveSearch = (e) => {
      e.preventDefault();
      Message.success(this.props.intl.formatMessage({ id: "global.saved" }));
      this.props.form.validateFields((err, values) => {
         console.log("Saved values of form: ", values);
      });
   };
   handleReset = () => {
      this.props.form.resetFields();
   };

   render() {
      const { value, role } = this.props;
      return (
         <Widget
            bgColor={value.backgroundColourHex}
            title={
               value.selectedWidgetId !== undefined
                  ? value.title + " " + value.selectedWidgetId
                  : value.title
            }
            styleName="gx-card-profile-sm"
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={<AdvancedSearchSettings value={value} />}
                  />
               )
            }
         >
            <Form className="advanced-search-form" onSubmit={this.handleSearch}>
               {value.searchInput !== undefined && value.searchInput ? (
                  value.searchInput.length > 0 ? (
                     <>
                        <div className="advanced-search-form__values">{this.getFields(value)}</div>
                        <div className="advanced-search-form__actions">
                           <Button buttonType="primary" htmlType="submit">
                              <IntlMessages id="settings.search" />
                           </Button>
                           <Button
                              buttonType="primary"
                              style={{ marginLeft: 8 }}
                              onClick={this.handleReset}
                           >
                              <IntlMessages id="settings.clear" />
                           </Button>
                           <Button buttonType="primary" onClick={this.saveSearch}>
                              <IntlMessages id="global.save" />
                           </Button>
                        </div>
                     </>
                  ) : (
                     "Configure search panel to display inputs."
                  )
               ) : (
                  "Configure search panel to display inputs."
               )}
            </Form>
         </Widget>
      );
   }
}
const AdvancedSearch = Form.create({ name: "advanced_search" })(WrappedAdvancedSearchForm);
export default injectIntl(AdvancedSearch);
